module.exports = __webpack_public_path__ + "img/emoji_65.7afc8c6c.png";